import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import LabelGeral from "../Componets/LabelGeral";
import Vector from "../imagem/Vector.svg";
import Input from "../Componets/Input";
import Textarea from "@mui/joy/Textarea";
import InputAcervo from "../Componets/inputAcervo";
import InputAutoComplete from "../Componets/InputAutoComplete";
import {
  CircularProgress,
  IconButton,
  InputBase,
  Paper,
  TextField,
} from "@mui/material";
import {
  getDadosLivroIsbn,
  getDadosLivroIsbnGoogle,
  getDadosLivroIsbnOpenLibrary,
} from "../services/api";
import { Search } from "@mui/icons-material";
import { toastWarning, toastError } from "../toasts/toast";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 740,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  height: 570,
  p: 4,
  borderRadius: 3,
};

function CadastrarLivro({ open, cancelar, cadastrar, options, load }) {
  const [localizacaoCadastro, setLocalizacaoCadastro] = useState("");
  const [tituloCadastro, setTituloCadastro] = useState("");
  const [autorCadastro, setAutorCadastro] = useState("");
  const [generoCadastro, setGeneroCadastro] = useState("");
  const [editoraCadastro, setEditoraCadastro] = useState("");
  const [isbnCadastro, setIsbnCadastro] = useState("");
  const [dataPublicacaoCadastro, setDataPublicacaoCadastro] = useState("");
  const [sinopseCadastro, setSinopseCadastro] = useState("");
  const [inputAcervo, setInputAcervo] = useState(1);
  const [loadIsbn, setLoadIsbn] = useState(false);

  function handleChangeData(event) {
    const { value } = event.target;
    const newValue = value.replace(/\D/g, "").slice(0, 4);
    setDataPublicacaoCadastro(newValue);
  }

  function handleIncrementAcervo() {
    setInputAcervo(inputAcervo + 1);
  }

  function handleDecrementAcervo() {
    if (inputAcervo > 0) setInputAcervo(inputAcervo - 1);
  }

  function SalvandoValoresCadastro() {
    const dadosSalvar = {
      titulo: tituloCadastro,
      isbn: isbnCadastro,
      dataPublicacao: Number(dataPublicacaoCadastro),
      quantidadeLivros: inputAcervo,
      genero: [generoCadastro],
      autor: autorCadastro,
      editora: editoraCadastro,
      localizacaoPratileira: localizacaoCadastro,
      sinopse: sinopseCadastro,
    };
    cadastrar(dadosSalvar);
  }

  async function buscarDadosLivro() {
    if (isbnCadastro === "" || !isbnCadastro) {
      toastWarning("ISBN vazio!");
      return;
    }
    try {
      setLoadIsbn(true);
      const { data: respostaApiOpenLibrary } =
        await getDadosLivroIsbnOpenLibrary(isbnCadastro);
      const dados = respostaApiOpenLibrary[`ISBN:${isbnCadastro}`];
      const { data: dadosGoogle } = await getDadosLivroIsbnGoogle(isbnCadastro);

      const dadosMontadosGoogle = {
        titulo: dadosGoogle.items?.[0]?.volumeInfo?.title || "",
        autor: dadosGoogle.items?.[0]?.volumeInfo?.authors?.join(", ") || "",
        editora: dadosGoogle.items?.[0]?.volumeInfo?.publisher || "",
        dataPublicacao: dadosGoogle.items?.[0]?.volumeInfo?.publishedDate || "",
        sinopse: dadosGoogle.items?.[0]?.volumeInfo?.description || "",
      };

      const dadosMontadosOpenLibrary = {
        titulo: dados?.details?.title || "",
        autor: dados?.details?.authors ? dados.details.authors[0]?.name : "",
        editora: dados?.details?.publishers ? dados.details.publishers[0] : "",
        dataPublicacao: dados?.details?.created?.value?.split("-")[0] || "",
        sinopse: dados?.details?.description?.value || "",
      };

      if (
        dadosMontadosOpenLibrary.titulo === "" &&
        dadosMontadosGoogle.titulo == ""
      ) {
        throw new Error("dados nao encontrados");
      }

      setTituloCadastro(
        dadosMontadosOpenLibrary.titulo || dadosMontadosGoogle.titulo || ""
      );
      setAutorCadastro(
        dadosMontadosOpenLibrary.autor || dadosMontadosGoogle.autor || ""
      );
      setEditoraCadastro(
        dadosMontadosOpenLibrary.editora || dadosMontadosGoogle.editora || ""
      );
      setSinopseCadastro(
        dadosMontadosOpenLibrary.sinopse || dadosMontadosGoogle.sinopse || ""
      );
      setDataPublicacaoCadastro(
        dadosMontadosOpenLibrary.dataPublicacao ||
          dadosMontadosGoogle.dataPublicacao ||
          ""
      );
    } catch (e) {
      toastWarning("Nenhum dado encontrado para o ISBN inserido!");
      setTituloCadastro("");
      setAutorCadastro("");
      setEditoraCadastro("");
      setSinopseCadastro("");
      setDataPublicacaoCadastro("");
    } finally {
      setLoadIsbn(false);
    }
  }

  useEffect(() => {
    if(!open){
      setAutorCadastro(null);
      setDataPublicacaoCadastro(null);
      setEditoraCadastro(null);
      setGeneroCadastro(null);
      setInputAcervo(null);
      setIsbnCadastro(null);
      setLocalizacaoCadastro(null);
      setSinopseCadastro(null);
      setTituloCadastro(null);
    }
  },[open])

  return (
    <div>
      <Modal
        open={open}
        onClose={cancelar}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "end",
                margin: -15,
              }}
            >
              <Button onClick={cancelar}>
                <img src={Vector} alt="" />
              </Button>
            </div>
            <Typography variant="h6" component="h6">
              Cadastrar novo livro
            </Typography>
          </div>

          <div
            style={{
              justifyContent: "space-between",
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "row",
              width: "100%",
              marginTop: 30,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <LabelGeral
                  nome="ISBN"
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                    left: 10,
                    fontFamily: "Roboto",
                  }}
                />
                <Input
                  value={isbnCadastro}
                  onChange={(e) => {
                    const newValue = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 20);
                    setIsbnCadastro(newValue);
                  }}
                  placeholder="xxxxxxxxxxxxxx"
                  width="129%"
                  height="40px"
                  padding="2px"
                />
              </div>
              <Button
                onClick={buscarDadosLivro}
                style={{
                  backgroundColor: "var(--cor-roxoEscuro)",
                  marginTop: 25,
                  marginLeft: 24,
                  borderBottomLeftRadius: 0,
                  borderTopLeftRadius: 0,
                  borderBottomRightRadius: 10,
                  borderTopRightRadius: 10,
                  width: 10,
                  height: 44,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {loadIsbn ? (
                  <CircularProgress
                    size={25}
                    style={{ fontSize: 20, color: "white" }}
                    color="white"
                  />
                ) : (
                  <Search
                    color="white"
                    style={{ color: "white", border: "none", outline: "none" }}
                  />
                )}
              </Button>
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <LabelGeral
                nome="Título"
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  left: 10,
                  fontFamily: "Roboto",
                }}
              />
              <Input
                value={tituloCadastro}
                onChange={(e) => setTituloCadastro(e.target.value)}
                disabled={false}
                placeholder="Título do livro"
                width="100%"
                height="40px"
                marginRight="105px"
                padding="2px"
              />
            </div>
          </div>

          <div
            style={{
              justifyContent: "space-between",
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "row",
              width: "100%",
              marginTop: 30,
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <LabelGeral
                nome="Autor"
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  left: 10,
                  fontFamily: "Roboto",
                }}
              />
              <Input
                value={autorCadastro}
                onChange={(e) => setAutorCadastro(e.target.value)}
                disabled={false}
                placeholder="Nome do autor"
                width="129%"
                height="40px"
                padding="2px"
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <LabelGeral
                nome="Editora"
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  left: 10,
                  fontFamily: "Roboto",
                }}
              />
              <Input
                value={editoraCadastro}
                onChange={(e) => setEditoraCadastro(e.target.value)}
                disabled={false}
                placeholder="Nome da editora"
                width="100%"
                marginRight="105px"
                height="40px"
                padding="2px"
              />
            </div>
          </div>

          <div
            style={{
              justifyContent: "space-between",
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "row",
              width: "106%",
              marginTop: 30,
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <InputAutoComplete
                label="Gênero"
                placeholder="Gênero"
                value={generoCadastro}
                change={(e) => setGeneroCadastro(e)}
                options={options}
                style={{
                  "& .MuiOutlinedInput-root": {
                    borderColor: "--cor-cinzaMargin",
                    borderRadius: "0.8em",
                    height: 50,
                  },
                  marginRight: 1,
                  width: 180,
                }}
              />
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: 5,
              }}
            >
              <LabelGeral
                nome="Acervo"
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  fontFamily: "Roboto",
                }}
              />
              <InputAcervo
                value={inputAcervo}
                onChange={setInputAcervo}
                onIncrement={handleIncrementAcervo}
                onDecrement={handleDecrementAcervo}
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <LabelGeral
                nome="Data de publicação"
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  left: 10,
                  fontFamily: "Roboto",
                }}
              />
              <Input
                value={dataPublicacaoCadastro}
                onChange={handleChangeData}
                placeholder="xxxx"
                width="75%"
                marginRight={20}
                height="40px"
                padding="2px"
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <LabelGeral
                nome="Localização"
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  left: 10,
                  fontFamily: "Roboto",
                }}
              />
              <Input
                value={localizacaoCadastro}
                onChange={(e) => setLocalizacaoCadastro(e.target.value)}
                disabled={false}
                placeholder=""
                width="75%"
                height="40px"
                padding="2px"
              />
            </div>
          </div>

          <div
            style={{ display: "flex", flexDirection: "column", marginTop: 25 }}
          >
            <LabelGeral
              nome="Sinopse"
              style={{
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
                left: 10,
                fontFamily: "Roboto",
              }}
            />

            <Textarea
              value={sinopseCadastro}
              onChange={(e) => setSinopseCadastro(e.target.value)}
              minRows={4}
              maxRows={4}
              sx={{
                backgroundColor: "white",
                marginTop: 1,
                height: 112,
              }}
            />
          </div>

          <div
            className="buttons"
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
              marginTop: 8,
              alignItems: "center",
            }}
          >
            <Button
              onClick={cancelar}
              variant="contained"
              style={{
                color: "var(--cor-roxoEscuro)",
                backgroundColor: "var(--cor-roxoInput)",
                border: "2px solid var(--cor-roxoEscuro)",
                borderRadius: "0.5em",
                fontSize: 18,
                width: 350,
                top: 34,
                boxShadow: "none",
              }}
            >
              Cancelar
            </Button>
            <Button
              onClick={SalvandoValoresCadastro}
              variant="contained"
              disabled={load}
              style={{
                color: "var(--cor-branco)",
                backgroundColor: "var(--cor-roxoEscuro)",
                border: "1px solid var(--cor-roxoEscuro)",
                borderRadius: "0.5em",
                fontSize: 18,
                width: 350,
                top: 34,
                boxShadow: "none",
              }}
            >
              {load ? (
                <CircularProgress sx={{ color: "white" }} />
              ) : (
                "Cadastrar"
              )}
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default CadastrarLivro;
